module.exports = __webpack_public_path__ + "img/1F1F6-1F1E6.1bf0da9e.svg";